import { DepositPromoId } from '../../../state/deposit/deposit.types';
import { DepositPromos } from '../Promos/Promos.types';
import { calculateReward, getRewardLabel } from '../Promos/Promos.utils';

export const getFooterTransOptions = (
  t: (key: string, options: Record<string, unknown>) => string,
  selectedPromoIds: DepositPromoId[],
  promos?: DepositPromos,
  selectedAmount?: number,
) => {
  if (!promos || !selectedPromoIds.length) {
    return [
      {
        ns: 'wallet',
        i18nKey: 'depositNoPromo',
      },
    ];
  }

  return selectedPromoIds.map((promoId) => {
    const promo = promos.byId[promoId];

    if (!promo) return null;

    const { rewards, rewardDescription, subTypeMeta } = promo;
    const { rewardTarget } = rewards[0] || {};
    const multiRewards = rewards.length > 1;

    if (multiRewards && rewardDescription) {
      return {
        ns: 'common',
        i18nKey: 'placeholder',
        values: { placeholder: rewardDescription },
      };
    }

    const rewardLabel = subTypeMeta?.percentage
      ? calculateReward(promo, selectedAmount)
      : getRewardLabel(promo, t);

    return rewardTarget === 'FreeSpins' && rewardDescription
      ? {
          ns: 'wallet',
          i18nKey: 'depositFooterFreeSpinsLabel',
          values: { rewardLabel, rewardDescription },
        }
      : {
          ns: 'common',
          i18nKey: 'placeholder',
          values: { placeholder: rewardLabel },
        };
  });
};
